import React from "react";
import { useSelector } from "react-redux";
import { makeSelectDealNotitficationsToUs } from "../../../../containers/App/selectors";
import { Badge, Button, Empty, Modal, Tooltip } from "antd";
import { NotificationOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import DealNotificationsList from "../../../../components/DealNotificationsList";

const DealNotificationsToUsBadge = React.memo(() => {
  const { t } = useTranslation("translations");

  const dealNotitficationsToUs = useSelector(makeSelectDealNotitficationsToUs());

  const [modalOpen, setModalOpen] = React.useState(false);

  if (!dealNotitficationsToUs) {
    return null;
  }

  return (
    <>
      <Tooltip title={t("deal_notification_count_to_us", { count: dealNotitficationsToUs.length })}>
        <Badge count={dealNotitficationsToUs.length} size="small" offset={[-5, 5]}>
          <Button
            aria-label={t("deal_notification_count_to_us", { count: dealNotitficationsToUs.length })}
            icon={<NotificationOutlined />}
            type="text"
            onClick={() => setModalOpen(true)}
          />
        </Badge>
      </Tooltip>
      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        destroyOnHidden
        footer={null}
        title={t("deal_notifications")}
        width={1000}
      >
        {dealNotitficationsToUs.length > 0 ? (
          <DealNotificationsList notifications={dealNotitficationsToUs} />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Modal>
    </>
  );
});

export default DealNotificationsToUsBadge;
